import React from 'react'
import './header.css'
import CTA from './CTA'
import ME from '../../assets/header1.png'
import HeaderSocial from './HeaderSocial'

const Header = () => {
  return (
    <header id="home">
      <div className="container header__container">
        <h5>Bonjour, I'm</h5>
        <h1>Ajay Singh</h1>
        <h5 className='text-light'>Software Engineer</h5>
        
        {/* This is the CTA Component */}
        <CTA />
        {/* <HeaderSocial /> */}

        <div className="me">
          <img src={ME} alt='me' />
        </div>

        {/* <a href='#contact' className='scroll__down'>Scroll Down</a> */}
      </div>
    </header>
  )
}

export default Header